
<text-input
  class="password-input"
  :id="id"
  :type="type"
  v-model="localValue"
  :label="label"
  :required="required"
  :disabled="disabled"
  maxlength="28"
>
  <icon-button
    class="show-hide"
    tabindex="-1"
    :icon="`${type === 'password' ? 'visibility' : 'visibility_off'}`"
    @click="toggleType"
  />
</text-input>
